module.exports = __webpack_public_path__ + "static/media/info.76a9d460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/info.jpg
// module id = 620
// module chunks = 0